import { useTranslation } from 'react-i18next';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import ReviewWithdrawal from '../../modules/withdrawal/ReviewWithdrawal';

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      left: '-15%',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      left: '-14%',
    },
    [theme.breakpoints.between('xs', 'md')]: {
      left: '-13%',
    },
    [theme.breakpoints.down('sm')]: {
      left: '-6%',
    },
  },
}));

interface ReviewParticularsPageProps {
  routeSteps: { label: string }[];
}

const ReviewWithdrawalPage = ({ routeSteps }: ReviewParticularsPageProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>ReviewWithdrawal.TitleHeader')} />
      <HeaderTemplate>
        <Stepper className={classes.stepper} activeStep={1} steps={routeSteps} />
      </HeaderTemplate>
      <ReviewWithdrawal />
    </>
  );
};

export default ReviewWithdrawalPage;
